 /* 
* Author : Sanjeev Kumar Mishra
* Funcitonality : Custom drop down select box
*/
const customCountrySelector = () => {
    var customSelect = $(".countrySelector:not(.init), .countryCodeSelector:not(.init)");

    $(document).on('input', '.search-country-input', function() {
        var searchTerm = $(this).val().toLowerCase(); 
        var anyVisible = false;
        $('.all-items .item').each(function() {
            var itemText = $(this).text().toLowerCase();
            var countryAttr = $(this).data('country')?.toLowerCase() || "";
            
            if (itemText.includes(searchTerm) || countryAttr.includes(searchTerm)) {
                $(this).show();
                anyVisible = true;
            } else {
                $(this).hide(); 
            }
        });
        $('.no-search-result').remove();
        if (!anyVisible) {
            $('.all-items').append('<div class="no-search-result" style="padding:10px;color:#999;">No matching countries found.</div>');
        }
    });

    customSelect.each(function() {
        var thisCustomSelect = $(this),
        selectElement = thisCustomSelect.find('select'),
        parentForm = thisCustomSelect.closest('form'),
        options = thisCustomSelect.find("option"),
        firstOptionText = options.first().text(),
        optionValue = thisCustomSelect.find('option:selected');
        
        var optionsSelected = ( thisCustomSelect.hasClass('country-wrapper') || thisCustomSelect.hasClass('stateSelector') ) ? 
        thisCustomSelect.find('option:selected').text() : thisCustomSelect.find('option:selected').attr('rel');
        
        var innerContent, selectedItem;

        /* render selected country if not selected then show first option to choose state */ 
        if( thisCustomSelect.hasClass('country-wrapper') ) {
            var countryList = (optionValue.attr('value') ? '<img width="18" src="' + thisCustomSelect.attr('data-url') + optionValue.attr('value').toLocaleLowerCase() + '.svg"/><span>'
                            + optionsSelected + '</span>' : '<span>'+ optionsSelected + '</span>');
            if (optionsSelected) {
                selectedItem = $('<div></div>', {
                    class: 'selected-country',
                }).insertAfter(selectElement).html(countryList);
            }else{
                var selectedItem = $("<div></div>", {
                    class: "selected-country"
                }).insertAfter(selectElement).text(
                    (optionValue.attr('value') ? '<img width="18" src="' + thisCustomSelect.attr('data-url') + optionValue.attr('value').toLocaleLowerCase() + '.svg"/><span>'
                            + firstOptionText + '</span>' : '<span>'+ firstOptionText + '</span>')
                );
            }
        }  

        /* render selected state if not selected then show first option to choose state */ 
        else if( thisCustomSelect.hasClass('stateSelector') ) {
            var stateList = ('<span>'+ optionsSelected + '</span>');
            if (optionsSelected) {
                selectedItem = $('<div></div>', {
                    class: 'selected-state position-static',
                }).insertAfter(selectElement).html(stateList);
            }
            else {
                var selectedItem = $("<div></div>", {
                    class: "selected-state position-static"
                }).insertAfter(selectElement).text(firstOptionText);
            }
        }
        
        /* render selected country code if not selected then show first option to choose country code */
        else {
            if (optionsSelected) {
                selectedItem = $('<div></div>', {
                    class: 'selected-countryCode',
                }).insertAfter(selectElement)
                .html('<img width="18" src="' + thisCustomSelect.attr('data-url') + optionValue.attr('value').toLocaleLowerCase() + '.svg"/><span>+'+ optionsSelected+'</span>');
            } else {
                var selectedItem = $("<div></div>", {
                    class: "selected-countryCode"
                }).insertAfter(selectElement)
                .html('&nbsp;');
            }
        }
        
        /* list down all the options */
        var allItems = $("<div></div>", {
            class: "all-items all-items-hide"
        }).insertAfter(selectedItem);
        
        if(selectElement.find('option').length > 1){
            $("<input>", {
                type: "text",
                class: "search-country-input",
                placeholder: "Type country name",
                autocomplete: "off"
            }).prependTo(allItems);
        }
        
        
        setTimeout(function() {
            handlePhoneInput(selectedItem, parentForm);
        },500);
        
        if( thisCustomSelect.hasClass('country-wrapper') ) {
            options.each(function() {
                var that = $(this),
                optionText = that.text();

                if(that.attr('rel')) {
                    innerContent = '<img width="18" src="' + thisCustomSelect.attr('data-url') + that.attr('value').toLocaleLowerCase() + '.svg"/><span>' + optionText + '</span>'
                } else {
                    innerContent = optionText
                }

                var item = $("<div></div>", {
                class: "item",
                rel: $(this).attr('rel'),
                value: $(this).attr('value'),
                attr: {
                    'data-country': optionText
                },
                on: {
                    click: function() {
                        selectedItem.empty().html($(this)[0].innerHTML).removeClass("arrowanim");
                        allItems.addClass("all-items-hide");

                        var ele = $(this)[0];

                        parentForm.find('.countryCodeSelector').find('select option').removeAttr('selected');
                        parentForm.find('.countrySelector').find('select option').removeAttr('selected');
        
                        if(ele.attributes.value != undefined) {
                            $(this).closest('.countrySelector').find('select option[value="'+$(this).attr('value')+'"]').attr('selected', 'selected');
                            parentForm.find('.countryCodeSelector').find('select option[value="'+$(this).attr('value')+'"]').attr('selected', 'selected');
                        } else {
                            $(this).closest('.countrySelector ').find('select').val(ele.innerHTML);
                            parentForm.find('.countryCodeSelector').find('select').val(parentForm.find('.countryCodeSelector').find('select').find('option:first').val());
                        }
                        parentForm.find('.countrySelector ').find('.selected-country').empty().html(ele.innerHTML);
                        parentForm.find('.countryCodeSelector').find('.selected-countryCode').empty().html(parentForm.find('.countryCodeSelector .item[value="' + $(this).attr('value') + '"]')[0].innerHTML);                    
                        parentForm.find('.countrySelector').find('select').trigger('change');    
                        parentForm.find('.countryCodeSelector').find('select').trigger('change');

                        setTimeout(function() {
                            handlePhoneInput($('.selected-countryCode'), parentForm);
                        },500);
                        
                    }
                }
                })
                .appendTo(allItems)
                .html(innerContent);
            });
        }

        else if (thisCustomSelect.hasClass('stateSelector')) {
            options.each(function() {
                var that = $(this),
                optionText = that.text();
        
                var item = $("<div></div>", {
                class: "item",
                rel: $(this).attr('value'),
                on: {
                    click: function() {
                        var selectedOptionText = that.text();
                        selectedItem.text(selectedOptionText).removeClass("arrowanim");
                        allItems.addClass("all-items-hide");
                    
                        let selectId = thisCustomSelect.find('select');
                        $(selectId + " option").removeAttr('selected');
                        
                        var id = that[0].id;
                        $(selectId + " option").filter(function(){
                            return this.id === id
                        }).prop('selected', true);  
                    }
                }
                })
                .appendTo(allItems)
                .text(optionText);
            });
        }

        else {

            
            options.each(function() {
                var that = $(this),
                optionText = that.attr('rel');
                let optionCountryName = that.text();
        
                if(optionText) {
                    innerContent = '<img width="18" src="' + thisCustomSelect.attr('data-url') + $(this).attr('value').toLocaleLowerCase() + '.svg"/><span>+'+ optionText+' -'+optionCountryName+'</span>'
                } else {
                    innerContent = 'Select Country Code'
                }
        
                var item = $("<div></div>", {
                class: "item",
                rel: $(this).attr('rel'),
                attr: {
                    'data-country': optionCountryName
                },
                value: $(this).attr('value'),
                on: {
                    click: function() {
                        selectedItem.empty().html($(this)[0].innerHTML).removeClass("arrowanim");
                        allItems.addClass("all-items-hide");

                        var ele = $(this)[0];
                        var imgHtml = ele.querySelector('img')?.outerHTML;
                        var spanText = ele.querySelector('span')?.innerText?.trim();
                        var countryCode = spanText?.split('-')[0]?.trim();
                        var finalHtml = imgHtml + '<span>' + countryCode + '</span>';
                        parentForm.find('.countryCodeSelector').find('.selected-countryCode').empty().html(finalHtml);
                        
                        parentForm.find('.countryCodeSelector').find('select option').removeAttr('selected');
                        parentForm.find('.countrySelector').find('select option').removeAttr('selected');

                        if(ele.attributes.value != undefined) {
                            parentForm.find('.countryCodeSelector').find('select option[value="'+$(this).attr('value')+'"]').attr('selected', 'selected');
                            parentForm.find('.countrySelector').find('select option[value="'+$(this).attr('value')+'"]').attr('selected', 'selected');

                            parentForm.find('.countrySelector').find('.selected-country').empty().html(parentForm.find('.countrySelector .item[value="' + $(this).attr('value') + '"]')[0].innerHTML);
                        } else {
                            parentForm.find('.countryCodeSelector').find('select').val(parentForm.find('.countryCodeSelector').find('select').find('option:first').val());
                            parentForm.find('.countrySelector').find('select').val(parentForm.find('.countrySelector').find('select').find('option:first').val());

                            parentForm.find('.countrySelector').find('.selected-country').empty().html(parentForm.find('.countrySelector').find('select').find('option:first').val());
                        }
                     
                       
                        
                        parentForm.find('form').find('.countryCodeSelector').find('select').trigger('change');
                        parentForm.find('form').find('.countrySelector').find('select').trigger('change');

                        setTimeout(function() {
                            handlePhoneInput(selectedItem, parentForm);
                        },500);
                    }
                }
                })
                .appendTo(allItems)
                .html(innerContent);
            });
        }
        customSelect.addClass('init');
    });

    var selectedItem = $(".selected-country, .selected-countryCode, .selected-state");

    selectedItem.on("click", function(e) {
        var _this = $(this);
        var currentSelectedItem = $(this);
        if( !$(this).next().hasClass('all-items-hide') ) {
            $(this).next().addClass('all-items-hide');
            currentSelectedItem.toggleClass("arrowanim");
        } else {
            setTimeout(function() {
                _this.closest('form').find('.all-items:not(.all-items-hide)').addClass("all-items-hide");
                allItems = currentSelectedItem.next(".all-items");
                allItems.removeClass("all-items-hide");
                selectedItem.not(currentSelectedItem).removeClass("arrowanim");
                currentSelectedItem.toggleClass("arrowanim");
            }, 300);
        }
        resetDropDownAllItems()
        e.stopPropagation();
    });

    $(document).on("click", function(e) {
        if (
            !$(e.target).closest(".selected-country, .selected-countryCode, .selected-state, .search-country-input").length
        ) {
            var opened = $(".all-items:not(.all-items-hide)");
            opened.addClass("all-items-hide");
            $('.search-country-input').val('');
            opened.prev().removeClass("arrowanim");
        }
    });

    /* adjust phone input left padding and label position based on the countrycode selcetion */
    function handlePhoneInput(selectElement, parentForm) {
        var phoneInput = parentForm.find(selectElement).closest(customSelect).find('input:not(.search-country-input)');
        var flagWrapper = phoneInput.closest(customSelect).find(selectedItem);

            if(!customSelect.hasClass('no-select')) {
                phoneInput.css('padding-left', ((flagWrapper.outerWidth() != 0 ? flagWrapper.outerWidth() + 22 : '70px')))
                .next('label').css('left', (flagWrapper.outerWidth() != 0 ? flagWrapper.outerWidth() + 22 : '70px' ) )
            } else {
                phoneInput.css('padding-left', (flagWrapper.outerWidth() != 0 ? flagWrapper.outerWidth() + 8 : '60px' ) )
                .next('label').css('left', (flagWrapper.outerWidth() != 0 ? flagWrapper.outerWidth() + 8 : '60px' ) );
            }
        
    }

    function resetDropDownAllItems(){
        $('.no-search-result').remove();
        $('.search-country-input').val('');
        $('.all-items .item').each(function() {
            $(this).show();
        });
    }
}

$(() => {
    customCountrySelector();
});

module.exports = {
    customCountrySelector,
};